module.exports = __webpack_public_path__ + "static/img/Hdefault.605a47a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/my/images/Hdefault.png
// module id = 8+TC
// module chunks = 0